<template>
  <div class="panel-ChatOrderPanel">
    <div class="h-100" v-if="tabPage === 0">
      <ChatOrderProfileCard
        :userInfo="orderSelected.buyerInfo.userInfo"
        :userChatInfo="userChatInfo"
        @handle-show-modal-user="$refs.ChatOrderProfileModalDetail.show()"
        isShowDetail
        class="pt-3 pb-2"
      />
      <!-- @handle-chage-page="(val) => (tabPage = val)" -->
      <div class="px-2">
        <hr class="text-muted my-0 mt-2" />
      </div>
      <b-tabs
        v-if="isShowOrder"
        v-model="tabIndex"
        content-class="mt-1 px-3"
        fill
      >
        <b-tab>
          <template #title>
            <font-awesome-icon :icon="['fas', 'cart-plus']" class="mr-2" />
            <strong>New Order</strong>
          </template>
        </b-tab>
        <b-tab>
          <template #title>
            <font-awesome-icon :icon="['fas', 'clipboard-list']" class="mr-2" />
            <strong>Order History</strong>
          </template>
        </b-tab>
      </b-tabs>
      <ChatOrderListPanel
        v-if="isShowOrder && userChatInfo.externalId && tabIndex == 0"
        :userDetail="userDetail"
        :userId="userChatInfo.externalId"
        :userInfo="orderSelected.buyerInfo.userInfo"
        :orderSelected="orderSelected"
        @set-buyer-info-select="val => (orderSelected.buyerInfo = val)"
        :handleFinishCreateOrder="handleFinishCreateOrder"
        :handleShowModalCopy="handleShowModalCopy"
        :onsetOrderSelected="onsetOrderSelected"
        class="pt-2"
        @set-address-from-list="handleGetAddressFromList"
      />
      <ChatOrderHistoryPanel
        v-if="isShowOrder && userChatInfo.externalId && tabIndex == 1"
        :userId="userChatInfo.externalId"
        :userDetail="userDetail"
        :userInfo="orderSelected.buyerInfo.userInfo"
        :orderSelected="orderSelected"
        :onsetOrderSelected="onsetOrderSelected"
        :handleShowModalCopy="handleShowModalCopy"
        @set-value-order-selected="val => (orderSelected = val)"
        class="pt-2"
      />
    </div>
    <!-- <ChatOrderProfilePanel
      v-if="tabPage === 1"
      :userInfo="userInfo"
      :userDetail="userDetail"
      :userChatInfo="userChatInfo"
      @handle-chage-page="(val) => (tabPage = val)"
      @handle-get-user-info="getUserInfo"
    /> -->
    <ChatOrderProfileModalDetail
      v-if="isShowOrder"
      ref="ChatOrderProfileModalDetail"
      :orderSelected="orderSelected"
      :userGUID="userChatInfo.externalId"
      :getUserInfo="getUserInfo"
    />
    <!-- :userInfo="orderSelected.buyerInfo.userInfo" -->
    <!-- v-bind:isShow="isShowModalAddress"
      v-on:setShowModalAddress="setShowModalAddress"
      v-bind:orderSelected="orderSelected"
      v-bind:orderStatus="orderSelected.statusId"
      v-bind:v="$v"
      :onUpdatedAddress="onUpdatedAddress" -->
    <!-- v-if="forceRefresh" -->
    <ModalCopyLink
      ref="modalCopyLink"
      :urlLink="urlLink"
      :remarkMessage="remarkMessage"
    />
  </div>
</template>

<script>
import ChatOrderProfileCard from "@/components/chat/chatOrder/chatOrderProfile/ChatOrderProfileCard";
// import ChatOrderProfilePanel from "@/components/chat/chatOrder/chatOrderProfile/ChatOrderProfilePanel";
import ChatOrderHistoryPanel from "@/components/chat/chatOrder/chatOrderHistory/ChatOrderHistoryPanel";
import ChatOrderProfileModalDetail from "@/components/chat/chatOrder/chatOrderProfile/ChatOrderProfileModalDetail";
import ChatOrderListPanel from "@/components/chat/chatOrder/chatOrderList/ChatOrderListPanel";
import ModalCopyLink from "@/components/modal/ModalCopyLink";

export default {
  name: "ChatOrderPanel",
  components: {
    ChatOrderProfileCard,
    // ChatOrderProfilePanel,
    ChatOrderHistoryPanel,
    ChatOrderProfileModalDetail,
    ChatOrderListPanel,
    ModalCopyLink
  },
  props: {
    userChatInfo: {
      required: false,
      type: Object
    },
    socialType: {
      required: false,
      type: Number
    }
  },
  data() {
    return {
      tabPage: 0,
      tabIndex: 0,
      orderSelected: {
        statusId: 0,
        buyerInfo: {
          userInfo: {},
          shippingAddress: {},
          billingAddress: {},
          sameAddress: true,
          isRequestTax: false,
          isShowOrder: true
        }
      },
      // userInfo: {},
      userDetail: {},
      defaultValueAddress: {
        id: 0,
        name: "",
        userGUID: "",
        defaultBilling: null,
        defaultShipping: null,
        firstname: null,
        lastname: null,
        address: null,
        road: null,
        district: null,
        subdistrict: null,
        province: null,
        zipcode: null,
        taxNo: null,
        zipcodeId: 0,
        nameTitleId: 0
      },
      // forceRefresh: true,
      // isShowModalAddress: false,
      remarkMessage: "",
      urlLink: ""
    };
  },
  methods: {
    onsetOrderSelected() {
      this.orderSelected = {
        branchId: null,
        brandId: this.$route.query.brandID,
        canDownloadJobSheet: false,
        canUpdateTracking: false,
        checkSum: "",
        countFreeProduct: 0,
        discount: 0,
        discountPromotion: 0,
        expiredDate: "",
        freeProducts: [],
        grandTotal: 0,
        id: 0,
        invoiceNo: "",
        isFreeProduct: false,
        note: "",
        paymentMethodId: 0,
        paymentName: "-",
        paymentReference: null,
        productDiscount: [],
        products: [],
        promotions: [],
        promoCode: "",
        promoCodeMessage: "",
        reasonId: 0,
        reasonNote: "",
        replyReferenceId: null,
        replyTypeId: 0,
        saleChannel: 0, //this.userInfo.socialSalesChannelId,
        shippingCost: 0,
        shippingTypeId: 0,
        shippingTypeName: "",
        socialRef: {},
        statusId: 1,
        statusName: "สั่งซื้อ",
        total: 0,
        totalQuantity: 0,
        trackingNo: {},
        userGUID: null,
        weightTotal: 0,
        buyerInfo: {
          userInfo: {
            telephone: null,
            firstname: null,
            lastname: null,
            email: null,
            socialMediaId: 0,
            socialMediaName: null,
            socialReferenceId: null,
            socialSourceId: this.socialType
          },
          shippingAddress: {
            id: 0,
            firstname: null,
            lastname: null,
            address: null,
            road: null,
            province: null,
            district: null,
            subdistrict: null,
            zipcode: null,
            shippingNote: ""
          },
          billingAddress: {
            id: 0,
            firstname: null,
            lastname: null,
            address: null,
            road: null,
            province: null,
            district: null,
            subdistrict: null,
            zipcode: null,
            shippingNote: ""
          },
          sameAddress: true,
          isConsent: false,
          isRequestTax: false
        }
      };
      this.getUserInfo();
      this.$store.dispatch("setIsLoading", false);
    },
    getUserInfo: function() {
      this.$axios
        .get(
          `${this.$baseUrlOrder}/api/user/guid/${this.userChatInfo.externalId}`
        )
        .then(response => response.data)
        .then(res => {
          if (res.result) {
            this.orderSelected.buyerInfo.userInfo = res.detail;
            this.orderSelected.saleChannel = res.detail.socialSalesChannelId;
            this.orderSelected.buyerInfo.sameAddress = res.detail.sameAddress;
            this.orderSelected.buyerInfo.isRequestTax =
              res.detail.isRequestTaxInvoice;
            if (this.orderSelected.id === 0)
              this.orderSelected.buyerInfo.userInfo.socialSourceId = this.socialType;

            // this.$axios
            //   .get(
            //     `${this.$baseUrl}/api/user/${this.userChatInfo.externalId}/address/list`
            //   )
            //   .then((respo) => respo.data)
            //   .then((result) => {
            //     if (result.result) {
            //       if (result.detail.length == 0) {
            //         this.orderSelected.buyerInfo.shippingAddress = this.defaultValueAddress;
            //         this.orderSelected.buyerInfo.billingAddress = this.defaultValueAddress;
            //       } else {
            //         this.orderSelected.buyerInfo.shippingAddress =
            //           result.detail[0];
            //         if (result.detail.length == 1) {
            //           this.orderSelected.buyerInfo.billingAddress =
            //             result.detail[0];
            //         }
            //         if (result.detail.length > 1) {
            //           this.orderSelected.buyerInfo.billingAddress =
            //             result.detail[1];
            //         }
            //       }
            //     }
            //   })
            //   .catch((error) => {
            //     console.log("error", error);
            //   });
          }
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    handleFinishCreateOrder() {
      this.tabIndex = 1;
      // this.getUserInfo();
      this.onsetOrderSelected();
    },
    handleShowModalCopy(resData) {
      this.remarkMessage = resData.message;
      this.urlLink = resData.urlLink;
      // setTimeout(() => {
      console.log(resData);
      this.$refs.modalCopyLink.show();
      // }, 500);
    },
    handleGetAddressFromList() {
      const tempAddressList = this.$store.getters.getChatUserAddressList;
      if (tempAddressList.length == 0) {
        this.orderSelected.buyerInfo.shippingAddress = this.defaultValueAddress;
        this.orderSelected.buyerInfo.billingAddress = this.defaultValueAddress;
      } else {
        this.orderSelected.buyerInfo.shippingAddress = tempAddressList[0];
        if (tempAddressList.length == 1) {
          this.orderSelected.buyerInfo.billingAddress = tempAddressList[0];
        }
        if (tempAddressList.length > 1) {
          this.orderSelected.buyerInfo.billingAddress = tempAddressList[1];
        }
      }
    }
    // setShowModalAddress(value) {
    //   // if (this.orderSelected.statusId !== 0) {
    //   console.log(this.isShowModalAddress);
    //   this.isShowModalAddress = value;
    //   console.log(this.isShowModalAddress);
    //   //   if (!value) {
    //   //     this.getOrderInformationById(this.orderSelected.id);
    //   //   }
    //   //   this.handleForcrrefresh();
    //   // }
    // },
    // onUpdatedAddress() {
    //   // this.handleAddress();
    //   // this.$v.orderSelected.buyerInfo.$touch();
    //   // if (this.$v.orderSelected.buyerInfo.$error) {
    //   //   return;
    //   // }
    //   // this.sendUpdatedAddress(this.orderSelected.buyerInfo);
    // },
    // handleForcrrefresh() {
    //   this.forceRefresh = false;
    //   this.$nextTick(() => {
    //     this.forceRefresh = true;
    //   });
    // },
  },
  created: async function() {
    // this.$store.commit("setShowProfileTab", false);
    this.isShowOrder = this.$store.getters.getIsShowProfileTab;
    this.onsetOrderSelected();
    // this.getUserInfo();
    this.$store.commit(
      "UPDATE_CHAT_USER_GUID_SELECTED",
      `${this.userChatInfo.externalId}`
    );
    this.$store.dispatch("handleGetChatAddressList");
  }
  // validations() {
  //   return {
  //     orderSelected: {
  //       buyerInfo: {
  //         userInfo: {
  //           firstname: { required, alpha },
  //           lastname: { required, alpha },
  //           email: { email },
  //           telephone: { required, minLength: minLength(9) },
  //         },
  //         shippingAddress: {
  //           firstname: { required, alpha },
  //           lastname: { required, alpha },
  //           telephone: { required, minLength: minLength(9) },
  //           address: { required },
  //           district: {
  //             required,
  //           },
  //           subdistrict: {
  //             required,
  //           },
  //           province: {
  //             required,
  //           },
  //           zipcode: {
  //             required,
  //             numeric,
  //             minValue: minValue(5),
  //           },
  //         },

  //         billingAddress: {
  //           nameTitleId: {
  //             required: requiredIf(function() {
  //               return (
  //                 !this.orderSelected.buyerInfo.sameAddress ||
  //                 this.orderSelected.buyerInfo.userInfo.isRequestTaxInvoice
  //               );
  //             }),
  //             valueDefault(value) {
  //               return valueDefault(
  //                 value,
  //                 !this.orderSelected.buyerInfo.sameAddress ||
  //                   this.orderSelected.buyerInfo.userInfo.isRequestTaxInvoice
  //               );
  //             },
  //           },

  //           firstname: {
  //             required: requiredIf(function() {
  //               return this.orderSelected.buyerInfo.sameAddress !== true;
  //             }),
  //             alpha,
  //           },
  //           lastname: {
  //             required: requiredIf(function() {
  //               return this.orderSelected.buyerInfo.sameAddress !== true;
  //             }),
  //             alpha,
  //           },

  //           address: {
  //             required: requiredIf(function() {
  //               return this.orderSelected.buyerInfo.sameAddress !== true;
  //             }),
  //           },
  //           district: {
  //             required: requiredIf(function() {
  //               return !this.orderSelected.buyerInfo.sameAddress;
  //             }),
  //           },
  //           subdistrict: {
  //             required: requiredIf(function() {
  //               return this.orderSelected.buyerInfo.sameAddress !== true;
  //             }),
  //           },
  //           province: {
  //             required: requiredIf(function() {
  //               return this.orderSelected.buyerInfo.sameAddress !== true;
  //             }),
  //           },
  //           zipcode: {
  //             required: requiredIf(function() {
  //               return this.orderSelected.buyerInfo.sameAddress !== true;
  //             }),
  //             numeric,
  //             minValue: minValue(5),
  //           },
  //           tax: {
  //             required: requiredIf(function() {
  //               return (
  //                 this.orderSelected.buyerInfo.sameAddress !== true ||
  //                 this.orderSelected.buyerInfo.userInfo.isRequestTaxInvoice ==
  //                   true
  //               );
  //             }),
  //             numeric,
  //             minValue: minValue(13),
  //           },
  //         },
  //       },
  //     },
  //   };
  // },
};
</script>

<style lang="scss" scoped>
.panel-ChatOrderPanel {
  height: 100vh;
}
::v-deep .nav-tabs .nav-link,
.nav-tabs .nav-item.show .nav-link {
  color: #707070 !important;
}
::v-deep .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border: 0px solid #832abf !important;
  color: #832abf !important;
  background-color: #ffffff !important;
  border-bottom: 4px solid #832abf !important;
}
::v-deep .nav-link:hover {
  border: 0px solid #a15ccf !important;
  border-bottom: 4px solid #9450c2 !important;
}
hr {
  border-color: #00001512;
}
@media (max-width: 767.98px) {
}
</style>
